const translations = {
  "en": {
    "Full Report": "Full Report"
  },
  "zh-tw": {
    "Full Report": "完整報告"
  }
};

export default translations;
